var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-card', [_c('div', {
    staticClass: "card-body"
  }, [_c('file-upload', {
    attrs: {
      "title": "Upload een bestand om orders te importeren. Ondersteunde formaten: Excel (.xlsx, .xls)",
      "url": _vm.getUrl(),
      "instructions": _vm.instructions,
      "accept": ".xlsx,.xls"
    },
    on: {
      "success": _vm.onUploadSuccess,
      "error": _vm.onUploadError,
      "reset": _vm.onReset
    }
  }), _vm.uploadStatus === 'success' ? _c('div', {
    staticClass: "alert alert-success status-message mt-4"
  }, [_c('h4', {
    staticClass: "instructions-title"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "check-circle"
    }
  }), _vm._v(" Bestand " + _vm._s(this.file.name) + " is succesvol geüpload en verwerkt ")], 1), _c('b-link', {
    attrs: {
      "to": _vm.orderLink(_vm.salesOrder.identifier)
    }
  }, [_vm._v("Ga naar de order")])], 1) : _vm._e(), _vm.uploadStatus === 'error' ? _c('div', {
    staticClass: "alert alert-danger status-message mt-4"
  }, [_c('h4', {
    staticClass: "instructions-title"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "times-circle"
    }
  }), _vm._v(" Bestand " + _vm._s(this.file.name) + " is niet verwerkt ")], 1), _vm.uploadMessage ? _c('ul', {
    staticClass: "instructions-list"
  }, [_c('li', [_vm._v(_vm._s(_vm.uploadMessage) + " "), _c('ul', _vm._l(_vm.additionalInfo, function (info, index) {
    return _c('li', {
      key: index
    }, [_vm._v(_vm._s(info))]);
  }), 0)])]) : _vm._e()]) : _vm._e()], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }